import { browserHistory } from 'configure/history';
import { addQuery, saveCurrentLocation } from 'components/QueryRoute';

type TOpenLoginViewProps = {
  routeToSaveInStorage?: string;
  query?: Record<string, any>;
};

export const openLoginView = ({
  routeToSaveInStorage,
  query = {}
}: TOpenLoginViewProps = {}) => {
  saveCurrentLocation('login', routeToSaveInStorage);
  browserHistory.push(addQuery({ accounts: '*', login: '*', ...query }));
};
